import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ChevronRight } from '@mui/icons-material';
import Image from '../Image';
import { MerchantPromoCardProps } from './types';
import sezzleTheme from '../../../../packages/website/src/templates/Page/themes';

const Container = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 16px 0;
  text-decoration: none;
`;

const ImageContainer = styled.div`
  width: 52px;
  height: 52px;
  border-radius: 50%;
  overflow: hidden;
`;

const ContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Title = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  text-align: left;
`;

const Pill = styled.p`
  margin: 0;
  font-size: 12px;
  background-color: ${sezzleTheme.backgroundColors.backgroundGreen};
  color: ${sezzleTheme.colors.text.green};
  font-weight: 600;
  text-align: left;
  border-radius: 16px;
  padding: 4px 12px;
  width: fit-content;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MerchantPromoCard: React.FC<MerchantPromoCardProps> = ({
  name,
  logo,
  merchantLink,
  pill,
}) => {
  const [merchantLinkWithTC, setMerchantLinkWithTC] = useState(merchantLink);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const query = window.location.search;
      const search = new URLSearchParams(query);
      const tc = search.get('tc');

      if (tc) {
        const [merchantBaseLink, merchantLinkQuery] = merchantLink.split('?');
        const merchantParams = new URLSearchParams(merchantLinkQuery);
        merchantParams.append('tc', tc);
        setMerchantLinkWithTC(
          merchantBaseLink + `?${merchantParams.toString()}`
        );
      }
    }
  }, [merchantLink]);

  return (
    <Container
      href={merchantLinkWithTC}
      target="_blank"
      title={name}
    >
      <ImageContainer>
        <Image fields={logo} />
      </ImageContainer>
      <ContentContainer>
        <Title>{name}</Title>
        {pill && <Pill>{pill}</Pill>}
      </ContentContainer>
      <IconContainer>
        <ChevronRight />
      </IconContainer>
    </Container>
  );
};

export default MerchantPromoCard;
